export const PRODUCT_TABS_SLIDER_CFG = [
  { width: 768, itemsToShow: 6, pagination: false },
  { width: 1024, itemsToShow: 7, pagination: false }
]

export const TABLE_TABS_SLIDER_CFG = [
  { width: 768, itemsToShow: 4, pagination: false },
  { width: 1400, itemsToShow: 5, pagination: false }
]

export const ACCOUNTS_TABS_SLIDER_CFG = [
  { width: 768, itemsToShow: 4, pagination: false },
  { width: 1024, itemsToShow: 5, pagination: false }
]

export const DEPOSIT_TABS_SLIDER_CFG = [{ width: 1, itemsToShow: 5, pagination: false }]

export const FAQ_TABS_SLIDER_CFG = [{ width: 1, itemsToShow: 5, pagination: false }]

export const BLOG_CATEGORIES_SLIDER_CFG = [{ width: 1, itemsToShow: 2, pagination: false }]

export const LAVERAGE_TABS_SLIDER_CFG = [{ width: 1, itemsToShow: 5, pagination: false }]
export const NEWS_SLIDER_CFG = [
  {
    width: 1,
    itemsToShow: 1,
    pagination: false,
    showArrows: true,
    itemPadding: [0, 13, 0, 0]
  }
]
